import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";

import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
    UploadButton,
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { Button } from '../../../components/button'
import { AssignmentButtonWrapper, AssignmentInputButtonContainer, TableWrapper } from '../../../styles/assignment/assignment';
import { Link } from 'react-router-dom';
import { Input } from '../../../components/input'
import { InputWrapper } from '../../../components/input/input.style'
import { Table } from '../../../components/table/table';
import { TableData } from '../../../services/tableData';
import { ExtraTableButtons } from '../../../styles/instructors/instructors';
import { MdCreate, MdDelete } from "react-icons/md";
import { CustomModal } from '../../../components/modal'
import { useState } from 'react';
import { SelectInput } from "../../../components/select/select";
import { Textarea } from "../../../components/textarea";
import { Checkbox } from "../../../components/checkbox";
// import { RowDots } from "../../../components/table/row-menu";


const schema = yup.object().shape({
    subjectName: yup.string().required("Subject Name is a required field"),
    subjectCode: yup.string().required("Subject Code is a required field"),
    class: yup.string().required("Class is a required field"),
    term: yup.string().required("Term is a required field"),
    subjectDetail: yup.string().required("Subject Detail is a required field"),
    elective: yup.bool()
        .oneOf([true, false])
});

const AdminSubjects = () => {
    const [showModal, setShowModal] = useState(false);
    const [imageUploadValue, setImageUploadValue] = useState('')

    const columns = [
        {
            name: "Name",
            selector: (row) => row.name,
        },
        {
            name: "Class",
            selector: (row) => row.class,
        },
        {
            name: "Date Submitted",
            selector: (row) => row.dateSubmitted,
        },
        {
            name: "Score",
            selector: (row) => row.score,
        },
        {
            name: "Date Scored",
            selector: (row) => row.dateScored,
        },
        {
            name: "Grade",
            selector: (row) => row.grade,
        },
        {
            name: "",
            selector: (row) => row.schoolCode,
            // width: "50px",
            cell: () => {
                // return (
                //     <RowDots
                //         options={["Edit Instructor", "Delete"]}
                //     // optionsFns={[() => router.push(`edit`)]}
                //     />
                // );
                return (
                    <ExtraTableButtons>
                        <div className="icon-container"><MdCreate /></div>
                        <div className="icon-container"><MdDelete /></div>
                    </ExtraTableButtons>
                );
            },
        },
    ];

    const classOptions = [
        {
            value: "jss1",
            label: "JSS 1",
        },
        {
            value: "jss2",
            label: "JSS 2",
        },
    ];

    const {
        handleSubmit,
        register,
        control,
        formState: { errors },
        // watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });

    const onSubmit = values => {
        console.log(values)
        setShowModal(false)
    }

    const handleImageUploadValue = (e) => {
        const file = e.target.files[0]
        setImageUploadValue(file.name)
    }

    return (
        <>
            <CustomModal title='Add Subject' onClose={() => setShowModal(false)} showModal={showModal}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <p style={{ marginTop: '2.4rem', fontSize: '1.2rem', fontWeight: '700', color: '#969696', }}>*You can make bulk uploads my using the Bulk upload field</p>
                    <InputWrapper>
                        <Input
                            id="subjectName"
                            type="text"
                            placeholder="Subject Name"
                            {...register("subjectName")}
                            error={errors.subjectName?.message}
                            fullWidth
                        />

                    </InputWrapper>
                    <InputWrapper className="grid-2-2">
                        <Input
                            id="subjectCode"
                            type="text"
                            placeholder="Subject Code"
                            {...register("subjectCode")}
                            error={errors.subjectCode?.message}
                            fullWidth
                        />
                        <Controller
                            control={control}
                            name="class"
                            render={({ field: { onChange } }) => (
                                <>
                                    <SelectInput
                                        id="class"
                                        type="text"
                                        placeholder="Select class"
                                        onChange={(val) => onChange(val.value)}
                                        error={errors.class?.message}
                                        options={classOptions}
                                    />
                                </>
                            )}
                        />

                    </InputWrapper>
                    <InputWrapper>
                        <Controller
                            control={control}
                            name="term"
                            render={({ field: { onChange } }) => (
                                <>
                                    <SelectInput
                                        id="term"
                                        type="text"
                                        placeholder="Select Term"
                                        onChange={(val) => onChange(val.value)}
                                        error={errors.term?.message}
                                        options={classOptions}
                                    />
                                </>
                            )}
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <Textarea
                            id="subjectDetail"
                            type="text"
                            placeholder="Subject Detail"
                            {...register("subjectDetail")}
                            error={errors.subjectDetail?.message}
                            fullWidth
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <Checkbox
                            id="elective"
                            label="Elective"
                            type="checkbox"
                            fullWidth
                            {...register("elective")}
                            error={errors.elective?.message}
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <AssignmentInputButtonContainer >
                            <Input value={imageUploadValue} fullWidth type='text' placeholder="Choose file" style={{ height: '42px' }} />

                            <label htmlFor="contained-button-file">
                                <input onChange={handleImageUploadValue} accept="image/*" id="contained-button-file" multiple type="file" style={{ display: 'none' }} />
                                <UploadButton variant="contained" component="span"
                                    disableElevation
                                    color="primary"
                                >
                                    BROWSE
                                </UploadButton>
                            </label>

                        </AssignmentInputButtonContainer>
                        <p style={{ marginTop: '1.6rem', fontSize: '1rem', color: '#969696', }}>*Uploaded file must be csv with the following headers; Name, Description, School Code, Highest Level etc.</p>
                    </InputWrapper>
                    <Button
                        type="submit"
                        style={{ marginLeft: 'auto', marginTop: '6rem' }}
                        responsive
                    >
                        ADD
                    </Button>
                </form>
            </CustomModal>
            <DashboardWrapper>
                <MainContentWrapper fullHeight>
                    <Container>
                        <MainContent>
                            <Heading>
                                Subjects
                            </Heading>
                            <Breadcrumb
                                crumbs={['Subjects']}
                            />
                            <div style={{ marginTop: '2.9rem' }}>
                                <AssignmentButtonWrapper>
                                    <Button size="small" onClick={() => setShowModal(true)}>ADD SUBJECT</Button>
                                    <Button size="small" variant="secondary">PRINT</Button>
                                </AssignmentButtonWrapper>
                                <TableWrapper>
                                    <Table
                                        columns={columns}
                                        data={TableData || []}
                                    />
                                </TableWrapper>
                            </div>
                        </MainContent>
                    </Container>
                </MainContentWrapper>
            </DashboardWrapper >
        </>
    )
}

export default AdminSubjects
